import { render, staticRenderFns } from "./main-sidebar - 副本.vue?vue&type=template&id=3cad3cc7&scoped=true"
import script from "./main-sidebar - 副本.vue?vue&type=script&lang=js"
export * from "./main-sidebar - 副本.vue?vue&type=script&lang=js"
import style0 from "./main-sidebar - 副本.vue?vue&type=style&index=0&id=3cad3cc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cad3cc7",
  null
  
)

export default component.exports